// extracted by mini-css-extract-plugin
module.exports = {"iconSVG":"KTooltip_iconSVG__3Rxkj","tooltipPopper":"KTooltip_tooltipPopper__RZ3OC"};